import React from "react";
import { Moon, Trash2, AlertTriangle } from "lucide-react";

/**
 * Floating bulk-action bar shown when leads are multi-selected.
 * Sticks to the bottom-center of the viewport.
 *
 * Primary action is "Op rust zetten" (soft-delete, omkeerbaar — auto-resurrect
 * zodra het pand opnieuw online komt). De harde "Definitief wissen" is
 * visueel duidelijk onderscheiden (rode rand, waarschuwingsicoon) zodat
 * meerdere collega's niet per ongeluk hard wissen wat enkel op rust moest.
 */
export default function LeadBulkBar({
  count, total, allSelected,
  onToggleAll, onClear, onArchive, onDelete,
}) {
  if (count === 0) return null;
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 flex items-center gap-3
                    bg-[var(--ink-900)] text-white px-4 py-2.5 rounded-full shadow-xl"
         data-testid="bulk-bar">
      <span className="text-[13px] font-medium">
        {count} van {total} geselecteerd
      </span>
      <button type="button" onClick={onToggleAll}
              data-testid="bulk-select-all"
              className="text-[12px] hover:text-[var(--teal-300)] underline-offset-2 hover:underline">
        {allSelected ? "Deselecteer alles" : "Selecteer alles"}
      </button>
      <span className="w-px h-5 bg-white/20" />
      <button type="button" onClick={onArchive}
              data-testid="bulk-archive"
              title="Op rust zetten — komt automatisch terug als pand opnieuw online verschijnt"
              className="flex items-center gap-1.5 bg-[var(--teal-700)] hover:bg-[var(--teal-800)] px-3 py-1.5 rounded-full text-[12px] font-medium">
        <Moon size={13} /> Op rust zetten
      </button>
      <button type="button" onClick={onDelete}
              data-testid="bulk-delete"
              title="Definitief wissen — enkel voor testdata of duplicaten"
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[12px] font-semibold
                         border-2 border-[#FF6B6B] bg-transparent text-[#FF6B6B]
                         hover:bg-[#B43232] hover:text-white hover:border-[#B43232]">
        <AlertTriangle size={12} /> Definitief wissen
      </button>
      <button type="button" onClick={onClear}
              data-testid="bulk-clear"
              className="text-[12px] text-white/70 hover:text-white">
        ✕
      </button>
    </div>
  );
}

export function leadDeleteMessage(ids) {
  if (!ids || !ids.length) return "";
  const what = ids.length === 1 ? "deze lead" : `${ids.length} leads`;
  return (
    `Je staat op het punt om ${what} definitief te wissen. ` +
    `Dit wist het pand en alle historie definitief. ` +
    `Gebruik dit enkel voor testdata of duplicaten, niet voor echte panden.`
  );
}
